module.exports = __webpack_public_path__ + "img/right_ways.bf50ea15.png";